export function range(val, min, max) {
	return Math.max( Math.min( val, max), min);
}
